import Fuse from 'fuse.js';

function filterResults(results, filters) {
  return results.filter((hikeResult) => {
    let matchedHike = true;
    // Handle if this is a Fuse result or not.
    const { fields } = hikeResult.item ? hikeResult.item : hikeResult;
    // Filter by details.
    const { trail_details } = fields;
    const { details } = filters;
    const { elevation, difficulty, distance } = details;
    // Filter by elevation.
    if ( elevation !== 'all' ) {
      matchedHike = false;
      switch (elevation) {
        case '500': {
          if (trail_details.trail_elevation) {
            let trailElevation = parseInt(trail_details.trail_elevation.replace(',', ''));
            if(trailElevation < 500) {
              matchedHike = true;
            }
          }
          break;
        }
        case '1000': {
          if (trail_details.trail_elevation) {
            let trailElevation = parseInt(trail_details.trail_elevation.replace(',', ''));
            if(trailElevation < 1000 && trailElevation > 500) {
              matchedHike = true;
            }
          }
          break;
        }
        case '2000': {
          if (trail_details.trail_elevation) {
            let trailElevation = parseInt(trail_details.trail_elevation.replace(',', ''));
            if(trailElevation < 2000 && trailElevation > 1000) {
              matchedHike = true;
            }
          }
          break;
        }
        case '3000': {
          if (trail_details.trail_elevation) {
            let trailElevation = parseInt(trail_details.trail_elevation.replace(',', ''));
            if(trailElevation < 3000 && trailElevation > 2000) {
              matchedHike = true;
            }
          }
          break;
        }
        case '3000+': {
          if (trail_details.trail_elevation) {
            let trailElevation = parseInt(trail_details.trail_elevation.replace(',', ''));
            if(trailElevation > 3000) {
              matchedHike = true;
            }
          }
          break;
        }
      }
    }
    // Filter by distance.
    if ( distance !== 'all' ) {
      matchedHike = false;
      switch (distance) {
        case '2': {
          if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 2) {
            matchedHike = true;
          }
          break;
        }
        case '5': {
          if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 5 && parseInt(trail_details.trail_distance) > 2) {
            matchedHike = true;
          }
          break;
        }
        case '8': {
          if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 8 && parseInt(trail_details.trail_distance) > 5) {
            matchedHike = true;
          }
          break;
        }
        case '10': {
          if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 10 && parseInt(trail_details.trail_distance) > 8) {
            matchedHike = true;
          }
          break;
        }
        case '10+': {
          if (trail_details.trail_distance && parseInt(trail_details.trail_distance) > 10) {
            matchedHike = true;
          }
          break;
        }
      }
    }
    // Filter by difficulty.
    if ( difficulty !== 'all' && difficulty !== trail_details.trail_difficulty ) {
      matchedHike = false;
    }

    // Filter by features.
    const { trail_features } = fields;
    const { features } = filters;
    const { views, history, waterfall, restroom, birds, floods, flowers, family, transit } = features;
    // Filter by views.
    if ( views && !trail_features.beautiful_views ) {
      matchedHike = false;
    }
    // Filter by history.
    if ( history && !trail_features.cultural_history ) {
      matchedHike = false;
    }
    // Filter by waterfall.
    if ( waterfall && !trail_features.waterfalls ) {
      matchedHike = false;
    }
    
    // Filter by restroom.
    if ( restroom && !trail_features.restrooms ) {
      matchedHike = false;
    }
    // Filter by birds.
    if ( birds && !trail_features.bird_watching ) {
      matchedHike = false;
    }
    // Filter by floods.
    if ( floods && !trail_features.ice_age_floods ) {
      matchedHike = false;
    }
    // Filter by flowers.
    if ( flowers && !trail_features.wildflowers ) {
      matchedHike = false;
    }
    // Filter by family.
    if ( family && !trail_features.family_friendly ) {
      matchedHike = false;
    }
    // Filter by public transit.
    if ( transit && !trail_features.public_transit ) {
      matchedHike = false;
    }

    // Return the result.
    return matchedHike;
  });
}

function toggleSignupModal() {
  const signupModal = document.getElementById('fah-email-signup');
  // Hide/Show the modal element.
  signupModal.classList.toggle('block');
  signupModal.classList.toggle('hidden');
  // Unlock/Lock the html and body scroll.
  document.documentElement.classList.toggle('overflow-hidden');
  document.body.classList.toggle('overflow-hidden');
}

async function emailSignupGating() {
  // Check if the has signed up for the email list local storage item exists.
  const hasSignedUp = localStorage.getItem('frcg-email-signup');
  // If the user has signed up, return true to let search continue.
  if (hasSignedUp) {
    return true;
  }
  // Get the search query count from local storage.
  const searchQueryCount = localStorage.getItem('frcg-search-query-count') || 0;
  // Iterate the search query count.
  localStorage.setItem('frcg-search-query-count', parseInt(searchQueryCount) + 1);
  // If the search query count is less than 3, return true to let search continue.
  if (searchQueryCount < 999999) {
    return true;
  }
  // Attach the signup form submit event.
  attachSignupFormSubmitEvent();
  // Toggle the signup modal.
  toggleSignupModal();
  // Return false to stop the search.
  return false;
}

function attachSignupFormSubmitEvent() {
  // Listen for the form submit event.
  const signupForm = document.querySelector('.ngp-form form');
  signupForm.addEventListener('submit', () => {
    // Set the email signup local storage item.
    localStorage.setItem('frcg-email-signup', 'true');
  });
}

export function render() {
  // Get the form element and results.
  const fahSearch = document.getElementById('fah-search');
  const fahSearchResults = document.querySelectorAll('.find-a-hike__hike');
  // Get the hike data.
  const { hikes } = frcg.fah;
  // Set up the Fuse instance.
  const options = {
    keys: ['title', 'description', ],
    useExtendedSearch: true,
    threshold: 0.3,
  };
  const hikesSearch = new Fuse(hikes, options);

  // Add form submit listener to the form.
  fahSearch.addEventListener('submit', async (e) => {
    // Prevent the default behavior and get form data.
    e.preventDefault();
    // Check if the user has signed up for the email list.
    const canSearch = await emailSignupGating();
    // If the user has not signed up, stop the search.
    if (!canSearch) {
      return;
    }
    const formData = new FormData(e.target);

    // Run the search.
    const trailQuery = formData.get('trail-name');
    const results = trailQuery ? hikesSearch.search(trailQuery) : hikes;
    // Filter the results.
    const filters = {
      details: {
        elevation: formData.get('filter-elevation'),
        difficulty: formData.get('filter-difficulty'),
        location: formData.get('filter-location'),
        distance: formData.get('filter-distance'),
      },
      features: {
        views: formData.get('filter-views') ? true : false,
        history: formData.get('filter-history') ? true : false,
        waterfall: formData.get('filter-waterfall') ? true : false,
        restroom: formData.get('filter-restroom') ? true : false,
        birds: formData.get('filter-birds') ? true : false,
        floods: formData.get('filter-floods') ? true : false,
        flowers: formData.get('filter-flowers') ? true : false,
        family: formData.get('filter-family') ? true : false,
        transit: formData.get('filter-public-transit') ? true : false,
      },
    };
    const filteredResults = filterResults(results, filters);
    // Hide all hikes.
    fahSearchResults.forEach((hikeResult) => {
      hikeResult.classList.remove('find-a-hike__hike--active');
    });
    // Show the results that match by IDs.
    for (const hikeSearchResult of filteredResults) {
      // Get the hike ID.
      const hikeSearchResultSlug = hikeSearchResult.item ? hikeSearchResult.item.slug : hikeSearchResult.slug;
      // Show the hike element.
      const hikeSearchResultElement = document.getElementById(`hike-${hikeSearchResultSlug}`);
      hikeSearchResultElement.classList.add('find-a-hike__hike--active');
    }
  });
  // Add form reset listener to the form.
  fahSearch.addEventListener('reset', () => {
    // Show all hikes.
    fahSearchResults.forEach((hikeResult) => {
      hikeResult.classList.add('find-a-hike__hike--active');
    });
  });
}
